"use client";

import React from "react";
import Navbar from "@/components/Navbar";
import Footer2 from "@/components/landing-page/Footer2";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import Link from "next/link";

export default function BlogPage() {
  const posts = [
    {
      title: "The 5 Tasks Every Business Is Still Doing Manually That Take 11 Minutes to Automate",
      slug: "5-tasks-every-business-still-doing-manually",
      excerpt: "There is a specific kind of waste that never shows up on a balance sheet. It does not look like a problem. It looks like work.",
      date: "April 28, 2026",
      readTime: "8 min read",
      category: "Operations",
      image: "/blog/5-tasks-none-need-human.png"
    },
    {
      title: "How AI is Reshaping Enterprise Automation in 2026",
      slug: "ai-reshaping-enterprise-automation-2026",
      excerpt: "The days of simple rule-based automation are over. Learn how cognitive agents are taking over complex workflows.",
      date: "April 19, 2026",
      readTime: "5 min read",
      category: "AI Trends",
      image: "/blog/ai-future.png"
    },
    {
      title: "Building Resilient AI Systems: Build vs Buy",
      slug: "building-resilient-ai-systems-build-vs-buy",
      excerpt: "When should you build your own AI infrastructure, and when should you rely on off-the-shelf tools?",
      date: "April 18, 2026",
      readTime: "7 min read",
      category: "Engineering",
      image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
    },
    {
      title: "The True Cost of Manual Data Entry",
      slug: "true-cost-of-manual-data-entry",
      excerpt: "Unpacking the hidden financial and operational costs of relying on humans for repetitive tasks.",
      date: "April 10, 2026",
      readTime: "4 min read",
      category: "Operations",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
    }
  ];

  return (
    <div className="min-h-screen bg-zinc-50 text-black selection:bg-indigo-100 relative flex flex-col">
      <Navbar isLoggedIn={false} />

      <main className="pt-32 pb-20 flex-grow">
        <section className="px-6 max-w-3xl mx-auto mb-16">
          <h1 className="text-3xl md:text-5xl font-semibold tracking-tight text-black mb-4 leading-[1.1]">
            Our <span className="text-black font-bold">Blog</span>
          </h1>
          <p className="text-base md:text-lg text-zinc-700 max-w-2xl leading-relaxed mb-8">
            Insights, engineering updates, and thoughts on the future of AI automation.
          </p>
          
          <div className="space-y-8">
            {posts.map((post, i) => (
              <Link href={`/blog/${post.slug}`} key={i} className="block group">
                <article className="bg-white border border-zinc-200 rounded-xl overflow-hidden hover:border-indigo-200 hover:shadow-md hover:shadow-indigo-100/50 transition-all flex flex-col md:flex-row h-full">
                  <div className="md:w-2/5 relative h-48 md:h-auto overflow-hidden bg-zinc-100">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="p-6 md:p-8 flex flex-col justify-center md:w-3/5">
                    <div className="flex items-center gap-4 text-[10px] font-mono text-zinc-600 mb-3">
                      <span className="text-black font-semibold uppercase tracking-wider">{post.category}</span>
                      <span className="flex items-center gap-1.5"><Calendar className="w-3 h-3" /> {post.date}</span>
                      <span className="flex items-center gap-1.5"><Clock className="w-3 h-3" /> {post.readTime}</span>
                    </div>
                    <h2 className="text-xl md:text-2xl font-bold text-black mb-2 group-hover:text-indigo-600 transition-colors">
                      {post.title}
                    </h2>
                    <p className="text-zinc-700 text-sm leading-relaxed mb-4">
                      {post.excerpt}
                    </p>
                    <div className="inline-flex items-center gap-2 text-xs font-medium text-black group-hover:gap-3 transition-all mt-auto">
                      Read Article <ArrowRight className="w-3.5 h-3.5" />
                    </div>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </section>
      </main>

      <Footer2 />
    </div>
  );
}
